import { Link } from 'react-router-dom'
import ScrollReveal from './ScrollReveal'
import { getAllPosts } from '../news'
import './LatestNewsPost.css'

function LatestNewsPost() {
  const posts = getAllPosts()
  const latestPost = posts[0]

  if (!latestPost) return null

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  return (
    <section className="latest-blog-section">
      <div className="latest-blog-container">
        <ScrollReveal>
          <div className="latest-blog-label">From the news</div>
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <Link to={`/news/${latestPost.slug}`} className="latest-blog-card">
            <div className="latest-blog-meta">
              <time dateTime={latestPost.date}>{formatDate(latestPost.date)}</time>
              <span className="latest-blog-tag">{latestPost.tags[0]}</span>
            </div>
            <h2 className="latest-blog-title">{latestPost.title}</h2>
            <p className="latest-blog-excerpt">{latestPost.excerpt}</p>
            <span className="latest-blog-link">Read article →</span>
          </Link>
        </ScrollReveal>
      </div>
    </section>
  )
}

export default LatestNewsPost
